import React from 'react';
import Icon from '../../../components/AppIcon';

const MenuFilters = ({ categories, activeFilters, setActiveFilters }) => {
  const dietaryOptions = [
    { id: 'all', name: 'All Dietary', icon: 'Utensils' },
    { id: 'halal', name: 'Halal', icon: 'Check' },
    { id: 'vegetarian', name: 'Vegetarian', icon: 'Leaf' },
    { id: 'vegan', name: 'Vegan', icon: 'Sprout' },
    { id: 'gluten-free', name: 'Gluten-Free', icon: 'Shield' }
  ];

  const spiceLevels = [
    { id: 'all', name: 'All Spice Levels', icon: 'Flame' },
    { id: 'none', name: 'No Spice', icon: 'Snowflake' },
    { id: 'mild', name: 'Mild', icon: 'Sun' },
    { id: 'medium', name: 'Medium', icon: 'Zap' },
    { id: 'hot', name: 'Hot', icon: 'Flame' },
    { id: 'fiery', name: 'Fiery', icon: 'Flame' }
  ];

  const mealTypes = [
    { id: 'all', name: 'All Meal Types', icon: 'Utensils' },
    { id: 'appetizer', name: 'Appetizers', icon: 'Coffee' },
    { id: 'main', name: 'Main Courses', icon: 'ChefHat' },
    { id: 'side', name: 'Sides', icon: 'Bowl' },
    { id: 'dessert', name: 'Desserts', icon: 'Cake' }
  ];

  const preparationTimes = [
    { id: 'all', name: 'All Prep Times', icon: 'Clock' },
    { id: 'quick', name: 'Quick (≤15 min)', icon: 'Zap' },
    { id: 'medium', name: 'Medium (16-25 min)', icon: 'Clock' },
    { id: 'slow', name: 'Slow (>25 min)', icon: 'Timer' }
  ];

  const FilterSection = ({ title, options, activeKey, onSelect }) => (
    <div className="mb-8">
      <h3 className="font-headline text-lg font-semibold text-text-primary mb-4">
        {title}
      </h3>
      <div className="space-y-2">
        {options.map(option => (
          <button
            key={option.id}
            onClick={() => onSelect(option.id)}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-organic ${
              activeKey === option.id
                ? 'bg-primary text-white shadow-warm'
                : 'text-text-primary hover:bg-primary-50 hover:text-primary'
            }`}
          >
            <Icon name={option.icon} size={18} />
            <span className="font-medium">{option.name}</span>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="bg-surface rounded-lg p-6 shadow-warm sticky top-24">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-headline text-xl font-semibold text-text-primary">
          Filter Menu
        </h2>
        <button
          onClick={() => setActiveFilters({
            category: 'all',
            dietary: 'all',
            spiceLevel: 'all',
            mealType: 'all',
            preparationTime: 'all'
          })}
          className="text-sm text-primary hover:text-primary-600 font-medium transition-organic"
        >
          Clear All
        </button>
      </div>

      <FilterSection
        title="Categories"
        options={categories}
        activeKey={activeFilters.category}
        onSelect={(value) => setActiveFilters(prev => ({ ...prev, category: value }))}
      />

      <FilterSection
        title="Dietary Preferences"
        options={dietaryOptions}
        activeKey={activeFilters.dietary}
        onSelect={(value) => setActiveFilters(prev => ({ ...prev, dietary: value }))}
      />

      <FilterSection
        title="Spice Level"
        options={spiceLevels}
        activeKey={activeFilters.spiceLevel}
        onSelect={(value) => setActiveFilters(prev => ({ ...prev, spiceLevel: value }))}
      />

      <FilterSection
        title="Meal Type"
        options={mealTypes}
        activeKey={activeFilters.mealType}
        onSelect={(value) => setActiveFilters(prev => ({ ...prev, mealType: value }))}
      />

      <FilterSection
        title="Preparation Time"
        options={preparationTimes}
        activeKey={activeFilters.preparationTime}
        onSelect={(value) => setActiveFilters(prev => ({ ...prev, preparationTime: value }))}
      />

      {/* Special Offers */}
      <div className="mt-8 p-4 bg-gradient-to-r from-accent-50 to-conversion-50 rounded-lg">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Star" size={20} className="text-accent-600" />
          <h4 className="font-headline font-semibold text-text-primary">
            Today's Special
          </h4>
        </div>
        <p className="text-sm text-text-secondary mb-3">
          Get 15% off on all Chef's Recommended dishes!
        </p>
        <button className="w-full bg-accent text-white font-medium py-2 px-4 rounded-lg hover:bg-accent-600 transition-organic">
          View Special Offers
        </button>
      </div>
    </div>
  );
};

export default MenuFilters;